import React from "react";
import { BirthDayTimeAndQnt } from "../../../models/BirthDaysModels/BirthDayTimeAndQnt";
import InputDate from "../../../../features/InputDate";
import { Grid } from "@material-ui/core";
import InputTimeForBirthDay from "../../../../features/InputTimeForBirthDay";
import BirthDayQnt from "./features/BirthDayQnt";
import { useTranslation } from "react-i18next";

interface IProps {
  reservationName: string;
  birthDayTimeAndQnt: BirthDayTimeAndQnt;
  onSetBirthDatTimeAndQnt: (value: BirthDayTimeAndQnt) => void;
  assortIds: string;
  onNext: () => void;
}

const SecondStep: React.FC<IProps> = ({
  birthDayTimeAndQnt,
  onSetBirthDatTimeAndQnt,
  assortIds,
  onNext,
  reservationName,
}: IProps) => {
  const { t } = useTranslation();
  const validateForm = () => {
    return Boolean(birthDayTimeAndQnt.date) && Boolean(birthDayTimeAndQnt.time) && Boolean(birthDayTimeAndQnt.qnt);
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "10px" }}>
        <div className="alert alert-yellow alert-big alert-thin" style={{ marginBottom: "16px" }}>
          <span>
            {t("wybrales")} <b>{reservationName}</b>, {t("teraz_pora_wybrac_godzine_zwiedzania")}
          </span>
        </div>
      </Grid>
      <Grid item xs={4} style={{ marginBottom: "10px" }}>
        <InputDate
          value={birthDayTimeAndQnt.date}
          label={t("wybierz_termin")}
          name={"date"}
          setDate={(date: string) => onSetBirthDatTimeAndQnt({ ...birthDayTimeAndQnt, date, time: "" })}
        />
      </Grid>
      <Grid item xs={4}>
        <InputTimeForBirthDay
          value={birthDayTimeAndQnt.time}
          label={t("wybierz_godzine_wejscia")}
          name={"ftime"}
          setTime={(time: string) => onSetBirthDatTimeAndQnt({ ...birthDayTimeAndQnt, time })}
          dateFrom={birthDayTimeAndQnt.date}
          dateTo={birthDayTimeAndQnt.date}
          assortIds={assortIds}
        />
      </Grid>
      <Grid item xs={4}>
        <BirthDayQnt
          value={birthDayTimeAndQnt.qnt}
          label={t("ilosc_osob")}
          onSetQnt={(qnt: number) => onSetBirthDatTimeAndQnt({ ...birthDayTimeAndQnt, qnt })}
        />
      </Grid>
      <Grid item xs={4} className={"button-next"} style={{ marginTop: 40 }}>
        {Boolean(birthDayTimeAndQnt.date) && Boolean(birthDayTimeAndQnt.time) && Boolean(birthDayTimeAndQnt.qnt) ? (
          <button
            className={"button medium padding-medium button-fill-main"}
            onClick={() => onNext()}
            disabled={!validateForm()}
          >
            {t("kontynuuj")}
          </button>
        ) : (
          <button className={"button medium padding-medium button-fill-gray"} disabled={!validateForm()}>
            {t("kontynuuj")}
          </button>
        )}
      </Grid>
    </Grid>
  );
};

export default SecondStep;
